import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-proteccion-seguridad',
  templateUrl: './proteccion-seguridad.component.html',
  styleUrls: ['./proteccion-seguridad.component.scss']
})
export class ProteccionSeguridadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
